import { atom, selectorFamily } from "recoil";
import { getRecoil } from "recoil-nexus";
import { isNullOrEmpty } from "shared/Helpers";

export const filteredDropDownOptionsState = atom({
  key: "filteredDropDownOptionsState",
  default: [],
});

export const filteredDropdownOptionsList = selectorFamily({
  key: "filteredDropdownOptionsList",
  get:
    (fieldMappingId) =>
    ({ get }) => {
      let filteredDropdownArray = [];

      if (!isNullOrEmpty(fieldMappingId)) {
        const arr = get(filteredDropDownOptionsState);
        if (arr.length !== 0) {
          filteredDropdownArray = arr.filter((item) => item.fieldMappingId == fieldMappingId);
        }
      }
      return filteredDropdownArray;
    },
});

export const removeOldFilteredDropdownOptions = (newSubsetOfFilteredDropdownOptions, isFromFNOL) => {
  let allFilteredDropdownOptions = getRecoil(filteredDropDownOptionsState);
  let filteredDropdownOptionsFromJSON = [];

  // if the filtered options are from the DB, we dont want to remove the filtered options from JSON if it exists
  if (!isFromFNOL){
    filteredDropdownOptionsFromJSON = allFilteredDropdownOptions.filter(option => 
      !isNullOrEmpty(option.parentId) &&
      option.fieldMappingId === newSubsetOfFilteredDropdownOptions[0].fieldMappingId
    );
  }

  let updatedAllFilteredDropdownOptions = allFilteredDropdownOptions.filter(
    (item) => newSubsetOfFilteredDropdownOptions[0].fieldMappingId !== item.fieldMappingId
  );
  
  return [...updatedAllFilteredDropdownOptions, ...filteredDropdownOptionsFromJSON];
};